import { styled, Grid } from '@mui/material';
import React from 'react';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, WIDGET_MEDIA_BORDER_RADIUS, DEFAULT_LINK_ID } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { ConditionalWrapper } from '../../HOCs/ConditionalWrapper/index.js';

var _a, _b, _c, _d, _e, _f, _g;
var CenterProductHeroContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main,
            background: brandclub_colors.greyBlackGround
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            background: brandclub_colors.greyBlackGround,
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            background: brandclub_colors.greyBlackGround,
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var Wrapper = styled('div')({
    width: '100%',
    maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});
var Title = styled('div')((_a = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        textAlign: 'center',
        fontSize: 43,
        fontWeight: 700,
        lineHeight: 1.2
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        fontSize: 26,
        padding: '0 20px',
    },
    _a));
var Paragraph = styled('div')((_b = {
        //   maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        maxWidth: 660,
        marginTop: 20,
        lineHeight: 1.6,
        fontSize: 16,
        fontWeight: 500,
        textAlign: 'center'
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        fontSize: 16,
        textAlign: 'center',
        padding: '0 20px',
    },
    _b));
var ProductSectionContainer = styled(Grid)((_c = {
        marginTop: 20,
        flexDirection: 'row'
    },
    _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        flexDirection: 'column',
    },
    _c['.highlights'] = (_d = {
            flex: 1,
            minHeight: 500,
            fontSize: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            minHeight: 0,
        },
        _d['&.mobile'] = (_e = {
                display: 'none'
            },
            _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                display: 'flex',
                img: {
                    maxWidth: '100%',
                    borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
                },
            },
            _e),
        _d['&.desktop'] = (_f = {
                display: 'block',
                borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
                overflow: 'hidden'
            },
            _f["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                display: 'none',
            },
            _f),
        _d['.highlight_detail'] = (_g = {
                paddingLeft: 20,
                paddingRight: 20,
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: 300,
                width: '100%',
                '.title': {
                    width: '100%',
                    marginBottom: 10,
                    fontWeight: 'bold',
                },
                '.subtitle': {
                    fontWeight: 500,
                    width: '100%',
                }
            },
            _g["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                maxWidth: '100%',
                marginTop: 30,
                marginBottom: 30,
            },
            _g),
        _d),
    _c['.highlight_image'] = {
        width: '100%',
        height: '100%',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
    },
    _c));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var CenterProductHero = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.paragraph, paragraph = _c === void 0 ? '' : _c, _d = _a.productImage, productImage = _d === void 0 ? '' : _d, link = _a.link, topLeftSection = _a.topLeftSection, bottomLeftSection = _a.bottomLeftSection, topRightSection = _a.topRightSection, bottomRightSection = _a.bottomRightSection, LinkComponent = _a.LinkComponent;
    var hasLink = !!link && !!link.id && !link.id.startsWith(DEFAULT_LINK_ID);
    var linkId = hasLink && link.id ? link.id : '/';
    return (React.createElement(CenterProductHeroContainer, null,
        React.createElement(Wrapper, null,
            title && React.createElement(Title, null, title),
            paragraph && React.createElement(Paragraph, null, paragraph),
            React.createElement(ProductSectionContainer, { container: true, wrap: "nowrap" },
                React.createElement("div", { className: "highlights mobile" },
                    React.createElement(ConditionalWrapper, { condition: hasLink, wrapper: function (children) { return React.createElement(LinkComponent, { to: linkId }, children); } },
                        React.createElement("img", { loading: "lazy", src: productImage, alt: 'pd' }))),
                React.createElement("div", { className: "highlights" },
                    React.createElement("div", { className: "highlight_detail" },
                        React.createElement("div", { className: "title" }, topLeftSection.title),
                        React.createElement("div", { className: "subtitle" }, topLeftSection.paragraph)),
                    React.createElement("div", { className: "highlight_detail" },
                        React.createElement("div", { className: "title" }, bottomLeftSection.title),
                        React.createElement("div", { className: "subtitle" }, bottomLeftSection.paragraph))),
                React.createElement("div", { className: "highlights desktop" },
                    React.createElement(ConditionalWrapper, { condition: hasLink, wrapper: function (children) { return React.createElement(LinkComponent, { to: linkId }, children); } },
                        React.createElement("div", { className: "highlight_image", style: {
                                backgroundImage: "url(".concat(productImage, ")"),
                                aspectRatio: 8 / 11,
                            } }))),
                React.createElement("div", { className: "highlights" },
                    React.createElement("div", { className: "highlight_detail" },
                        React.createElement("div", { className: "title" }, topRightSection.title),
                        React.createElement("div", { className: "subtitle" }, topRightSection.paragraph)),
                    React.createElement("div", { className: "highlight_detail" },
                        React.createElement("div", { className: "title" }, bottomRightSection.title),
                        React.createElement("div", { className: "subtitle" }, bottomRightSection.paragraph)))))));
};

export { CenterProductHero };
//# sourceMappingURL=index.js.map
